export const transmittersViewValidations = {
  data() {
    return {
      editTransmitterFormRules: {
        field_id: [
          {
            required: true,
            message: this.$t("transmitters.validations.enter_select_field"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("transmitters.validations.enter_name"),
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            message: this.$t("transmitters.validations.enter_latitude"),
            trigger: "blur",
          },
        ],
        longitude: [
          {
            required: true,
            message: this.$t("transmitters.validations.enter_longitude"),
            trigger: "blur",
          },
        ],
      },
    };
  },
};
